export const environment = {
  production: true,
  siteUrl: 'https://staging.flourish.wine',
  apiBaseUrl: 'https://api.staging.flourish.wine/api',
  partnerPortalUrl: 'https://partner.staging.flourish.wine',
  featureFlags: {
    showAppPromoOnMobile: false
  },
  firebaseConfig: null
};
